import React,{useRef,useEffect,useState} from 'react';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import SearchIcon from '@mui/icons-material/Search';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import AppBar from '@mui/material/AppBar';
import { alpha } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import AccountForApprovalInformationDialog from './AccountForApprovalInformationDialog'
import LinearProgress from '@mui/material/LinearProgress';
import Slide from '@mui/material/Slide';
import axios from 'axios'
import CloseIcon from '@mui/icons-material/Close';


const drawerWidth = 300;


const useStyles = makeStyles((theme) => ({
  appBarSpacer: theme.mixins.toolbar,
  appBar: {
      position: 'fixed',
  },
    menuButton: {
      marginRight: theme.spacing(2),
      [theme.breakpoints.up('sm')]: {
        display: 'none',
      },
    },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(3),
      width: 'auto',
    }
   
  },
  appBarBottom: {
    top: 'auto',
    bottom: 0,
    backgroundColor:"#ffffff",
    [theme.breakpoints.up('sm')]: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
      },
  },
  grow: {
    flexGrow: 1,
  },

}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const filter = createFilterOptions();

function AccountsForApprovalDialog(props) {

    const classes = useStyles();
    const [value, setValue] = useState(null);
    const accountsElement = useRef();
    const [openCreateEditAccount,setOpenCreateEditAccount] = useState(false)
    const [accountsForApproval,setAccountsForApproval] = useState([])
    const [selectedAccountForApproval,setSelectedAccountForApproval] = useState()
    const [accountAction,setAccountAction] = useState()
    const [showAccountInformation,setShowAccountInformation] = useState(false)
    const [showCreateAccountViaCsvDialog,setShowCreateAccountViaCsvDialog] = useState(false)
    const [isLoading,setIsLoading] = useState(false)
    const [showAccountForApprovalDialog,setShowAccountForApprovalDialog] = useState(false)
    const [accountsLabel, setAccountsLabel] = useState("")
  
    const editAccountClickListener = (event)=>{
      setAccountAction('edit')
      setShowAccountInformation(false)
      setOpenCreateEditAccount(true)
      
      
    }

    function reloadAccounts(){
      loadAccounts()
    }

    useEffect(()=>{
      setAccountsLabel(props.accountsLabel)
      loadAccounts()

    },[])

    function loadAccounts(){

      setIsLoading(true)

      const options = {
        method: 'POST',
        url: '/TransactiSellerPotentialAccounts/getAccountsForApproval.json',
        data:objectToFormData({search_term:""})
      }
       axios(options)
         .then(res => {

          setIsLoading(false)
         
          const isSuccess = res.data.response.is_success

          if(!isSuccess){
            alert("Error encounter")


            return;
          }
       
          setAccountsForApproval(res.data.response.AccountsForApproval)
          
          
         }).catch(error => {
  
           setIsLoading(false)
            // setIsSavingSuccess(false)
            alert("Error encounter")
           console.log(error)
  
         })
    }

    const objectToFormData = (object) => Object.keys(object).reduce((formData, key) => {
      formData.append(key, object[key]);
      
    return formData;
  }, new FormData());

    function autoComplete (){
       
        return(<Autocomplete
              value={value}
              onChange={(event, newValue) => {
                if (typeof newValue === 'string') {
                  setValue({
                    account_name: newValue,
                  });
                } else if (newValue && newValue.inputValue) {
                  // Create a new value from the user input
                  setValue({
                    account_name: newValue.inputValue,
                  });
                } else {
                  setValue(newValue);
                }
              }}
              filterOptions={(options, params) => {
                const filtered = filter(options, params);
        
                // Suggest the creation of a new value
                if (params.inputValue !== '') {
                  filtered.push({
                    inputValue: params.inputValue,
                    store_name: `Add "${params.inputValue}"`,
                  });
                }
        
                return filtered;
              }}
              selectOnFocus
              clearOnBlur
              handleHomeEndKeys
              options={accountsForApproval}
              getOptionLabel={(option) => {
                // Value selected with enter, right from the input
                if (typeof option === 'string') {
                  return option;
                }
                // Add "xxx" option created dynamically
                if (option.inputValue) {
                  return option.inputValue;
                }
                // Regular option
                return option.account_name;
              }}
             
              renderOption={(props, option) => {
                return (
                  <li {...props} key={option.account_name+option.id}>
                    {option.account_name}
                  </li>
                );
              }}

              style={{ width: '100%',paddingLeft:'8px'}}
             
              renderInput={(params) => (
                <TextField variant='standard' {...params}  InputProps={{...params.InputProps, disableUnderline: true}}  />
              )}
            />
          )
        }
    function search(){
        return (
          <div position="static" style={{border:".1rem solid #989898",borderRadius:"4px",margin:'2px'}}>
              <Toolbar variant="dense" style={{padding:'0'}}>
                  <Box flexGrow={1}>{autoComplete()}</Box>
                  <Box>
                  <IconButton className={classes.margin} size="large">
                  <SearchIcon />
                  </IconButton>
                  </Box>
              </Toolbar>
          </div>
        );
      }
      function accountElement(account){
          return(<div>
            <Typography variant="h6" gutterBottom>
                {account.account_name} ({account.contact_number})
            </Typography>
            <Typography variant="body1" gutterBottom>
                {account.street} {account.barangay} {account.city_municipality} {account.province}
            </Typography>
               
            

          </div>)
      }
   
    
      useEffect(()=>{
       
      },[accountAction])
    return (
      <div>
           <Dialog fullScreen open={props.showAccountForApprovalDialog} onClose={()=>{

              //props.setAccountActionListener("add")


              }} TransitionComponent={Transition}>
            <AppBar className={classes.appBar}>
                <Toolbar>
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={()=>{
                            
                           props.setShowAccountForApprovalDialog(false)
                            
                        }
                            
                            
                        }
                        aria-label="close"
                        size="large">
                    <CloseIcon />
                    </IconButton>
                    <Typography variant="subtitle1" className={classes.title}>
                    {Object.keys(accountsLabel).length === 0 ? "Account" : accountsLabel.singular} for approval
                    </Typography>
                </Toolbar>
            </AppBar>
            <div className={classes.appBarSpacer}></div>
         {search()}
         {isLoading ? <LinearProgress color="secondary"  style={{marginLeft:'.1rem',marginRight:'.1rem'}}/> : ''}
         <List ref={accountsElement}>
           {
               accountsForApproval.map((account,index)=>{ 
                   return(
                       <div key={account.id} onClick={()=>{
                         setSelectedAccountForApproval(account)
                         setShowAccountInformation(true)
                         setShowAccountForApprovalDialog(true)
                       }}>
                       <ListItem button>
                         {accountElement(account)}
                       </ListItem>
                      <Divider />
                   </div>
                   )
               })
              
           }
           
           </List>
          
           </Dialog>

           {showAccountForApprovalDialog ? <AccountForApprovalInformationDialog selectedAccountForApproval={selectedAccountForApproval} showAccountForApprovalDialog={showAccountForApprovalDialog} setShowAccountForApprovalDialog={setShowAccountForApprovalDialog}/>:""}
      
      </div>
      
    );

}

export default AccountsForApprovalDialog

